import { FC, memo, useMemo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Table, TableColumn } from 'ui/components'

import { DocumentsTableProps, Files } from './DocumentsTableProps'
import { columns } from './columns'

export const DocumentsTable: FC<DocumentsTableProps> = memo((props) => {
  const { files, readonly, isLoading, isDeleting, onDelete } = props

  const mappedFiles = useMemo(
    () =>
      files.map((el) => ({
        item: el
      })),
    [files]
  )

  return (
    <Table<Files>
      dataQa={TableDataQa.ONBOARDING_FORM_DOCUMENTS_LIST}
      columns={columns(readonly, onDelete) as TableColumn<Files>[]}
      dataSource={mappedFiles}
      loading={isLoading || isDeleting}
    />
  )
})
